<template>
  <v-card class="mb-2 py-0" color="grey lighten-4">
    <v-card-title class="ma-0 py-0"
      ><h5 class="h5">Day {{ day }} ({{ date | formatDate }})</h5></v-card-title
    >
    <v-card-text class="pt-0">
      <v-list class="py-0 pl-0">
        <draggable :list="services" group="services" @change="onDragChange"
          ><v-list-item v-for="service in services" :key="service.id" dense>
            <v-list-item-icon>
              <v-row justify="center">
                <v-icon>{{ supplierTypeIcon(service.serviceType) }}</v-icon>
              </v-row>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                <v-container fluid py-0>
                  <v-row
                    ><strong>{{ service.supplierName }}</strong>
                    -
                    {{ service.serviceName }} (Ad: {{ service.adults }}/Ch:
                    {{ service.children }}), Duration: &nbsp;
                    <v-edit-dialog large @save="onItemSaveDuration(service)">
                      <strong>{{ service.duration }}</strong>
                      <template v-slot:input>
                        <v-text-field
                          v-model.number="service.duration"
                          type="number"
                          label="Edit"
                          single-line
                          min="1"
                          :max="service.maxDuration"
                        ></v-text-field>
                      </template>
                    </v-edit-dialog>
                  </v-row>
                </v-container>
              </v-list-item-title>
              <v-list-item-subtitle v-if="service.extras">{{
                service.extras.map((e) => `${e.qty}x ${e.name}`).join(", ")
              }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-row align="center">
                <v-btn icon small @click="onEditItem(service)">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon x-small v-on="on" color="teal">mdi-pencil</v-icon>
                    </template>
                    <span>Edit</span>
                  </v-tooltip>
                </v-btn>
                <v-tooltip bottom v-if="service.hasPurchaseInvoice">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small>mdi-information-variant</v-icon>
                  </template>
                  <span
                    >This service cannot be deleted because there is a purchase
                    invoice associated with it. If you remove the purchase
                    invoice in the Accounts section then you can delete this
                    service.</span
                  >
                </v-tooltip>
                <v-btn
                  v-else
                  icon
                  small
                  class="mx-0"
                  @click="onDeleteItem(service)"
                >
                  <v-icon x-small color="pink">mdi-delete</v-icon>
                </v-btn>
                <v-btn small class="ma-0" text icon>
                  <v-icon small>mdi-drag</v-icon>
                </v-btn>
              </v-row>
            </v-list-item-action>
          </v-list-item>
        </draggable>
      </v-list>
      <div v-if="debug">
        <code>{{ services }}</code>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import draggable from "vuedraggable";
const moment = require("moment");
import { SupplierTypeIconMixin } from "../../../../mixins/SupplierTypeIconMixin";
import { itiItemDuration } from "../../../../helpers/index";
export default {
  name: "itinerary-builder-drag-and-drop-day",

  props: {
    day: {
      type: Number,
      default: () => 1,
    },
    items: {
      type: Array,
      default: () => [],
    },
    startDate: {
      type: String,
      default: () => null,
    },
    maxDuration: {
      type: Number,
      default: () => 1,
    },
  },

  components: { draggable },

  mixins: [SupplierTypeIconMixin],

  data() {
    return {
      debug: false,
      services: this.getItemsForDay(),
    };
  },

  computed: {
    date() {
      if (this.startDate != "") {
        return moment(this.startDate)
          .add(this.day - 1, "days")
          .format("YYYY-MM-DD");
      }
      return moment().format("YYYY-MM-DD");
    },
  },

  watch: {
    items(newVal) {
      this.services = this.getItemsForDay();
    },
  },

  methods: {
    onDragChange(payload) {
      this.$emit("change", {
        ...payload,
        day: this.day,
        date: this.date,
      });
    },
    getItemsForDay() {
      if (this.items.length > 0) {
        const day = moment(this.startDate).add(this.day - 1, "days");
        return this.items
          .filter((item) => day.isSame(moment(item.startDate), "day"))
          .map((item) => {
            return {
              ...item,
              maxDuration: this.itemMaxDuration(item),
              duration: itiItemDuration(item),
            };
          });
      } else {
        return [];
      }
    },
    itemMaxDuration(item) {
      return this.maxDuration;
    },
    onDeleteItem(item) {
      this.services = this.services.filter((i) => item.id != i.id);
      this.$emit("item-delete", { ...item });
    },
    onEditItem(item) {
      this.$emit("item-edit", { ...item });
    },
    onItemSaveDuration(payload) {
      let duration = Number(payload.duration);
      if (payload.serviceType != "ACCOMMODATION") {
        duration--;
      }
      payload.endDate = moment(payload.startDate)
        .add(duration, "days")
        .format("YYYY-MM-DD");
      this.$emit("item-changed", payload);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/ItineraryBuilderDragAndDropDay.vue